<template>
  <img
    :src="getAssetUrl('images/vetster-plus-badge.svg')"
    alt="Vetster Plus"
  />
</template>

<script>
import { getAssetUrl } from '@/helpers/url';

export default {
  name: 'VetsterPlusBadge',

  methods: { getAssetUrl },
};
</script>
